// extracted by mini-css-extract-plugin
export default {"link":"CardLink_link__9kFVD"};